import React from 'react';

export function combineComponents(components) {
  return ({ children }) =>
    components.reduceRight(
      (combinedComps, Comp) => <Comp>{combinedComps}</Comp>,
      children,
    );
}
